<script setup>

</script>

<template>
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <path d="M24.3,36.18h-6.95v-7.03l18.98-17.45c.3-.31,1.55-1.47,3.33-1.51.86-.02,2.15.23,3.44,1.52,2.53,2.53,1.54,5.54.25,6.94l-.09.09-18.96,17.43ZM20.35,33.18h2.78l18.04-16.58c.37-.44,1.03-1.54-.19-2.76-.44-.44-.84-.66-1.24-.64-.57,0-1.11.44-1.27.61l-.08.08-18.05,16.59v2.71Z" fill="currentcolor"/>
    <polygon points="32.52 43.48 .32 43.48 .32 4.86 3.63 1.55 32.52 1.55 32.52 11.85 29.52 11.85 29.52 4.55 4.87 4.55 3.32 6.1 3.32 40.48 29.52 40.48 29.52 35.61 32.52 35.61 32.52 43.48" fill="currentcolor"/>
  </svg>
</template>

<style scoped lang="scss">

</style>